import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { key: 3 }
const _hoisted_5 = { key: 4 }

import OrderLineList from  "@/components/lists/order_line.vue"
  import {Order as OrderClient} from "@/endpoints/rutsolve/gql/resolvers/order"
  import {onBeforeMount, ref} from "vue"
  import {Order} from "@/endpoints/rutsolve/gql/generated/graphql"
  import ErrorModal from "@/components/modals/error.vue"
  import Button from "@/components/button.vue"
  import OrderLineEditor from "@/components/editors/order_line.vue"
  import ContentModal from "@/components/modals/content.vue"
  import {Email as EmailClient} from "@/endpoints/rutsolve/rest/email"
  import FileList from "@/components/lists/file.vue"
  import FileEditor from "@/components/editors/file.vue"

  
export default /*@__PURE__*/_defineComponent({
  __name: 'order',
  props: {
    orderID: {
      default: null,
      required: true,
      type: String
    }
  },
  setup(__props) {

  const props = __props

  const error = ref<Error>(null)
  const orderClient = new OrderClient()
  const order = ref<Order>(null)
  const selectedFileIndex = ref<number>(null)
  const selectedOrderLineIndex = ref<number>(null)

  onBeforeMount( () => {
    read()
  })
  
  async function read() {
    try {
      order.value = await orderClient.summary(props.orderID)
    } catch(e) {
      error.value = e
    }
  }

  async function mailInvoice() {
    try {
      await EmailClient.invoice(order.value.id)
    } catch(e) {
      error.value = e
    }
  }

  async function mailOffer() {
    try {
      await EmailClient.offer(order.value.id)
    } catch(e) {
      error.value = e
    }
  }

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (_openBlock(), _createBlock(_component_scoped, null, {
    default: _withCtx(() => [
      _cache[22] || (_cache[22] = _createElementVNode("h1", null, " Order ", -1)),
      (order.value)
        ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _cache[7] || (_cache[7] = _createElementVNode("th", null, " Total Price ", -1)),
                _createElementVNode("td", null, [
                  (order.value.price)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(order.value.price.grossTotal.toFixed(2)), 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[8] || (_cache[8] = _createElementVNode("th", null, " Currency ", -1)),
                _createElementVNode("td", null, _toDisplayString(order.value.currency), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[9] || (_cache[9] = _createElementVNode("th", null, " Memorandum ", -1)),
                _createElementVNode("td", null, _toDisplayString(order.value.memorandum), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[10] || (_cache[10] = _createElementVNode("th", null, " Paid ", -1)),
                _createElementVNode("td", null, [
                  (order.value.paid)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(order.value.paid.toFixed(2)), 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[11] || (_cache[11] = _createElementVNode("th", null, " Received ", -1)),
                _createElementVNode("td", null, [
                  (order.value.received)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(order.value.received.toFixed(2)), 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (order.value && order.value.orderLines)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _cache[13] || (_cache[13] = _createElementVNode("h2", null, " Order Lines ", -1)),
            _createVNode(OrderLineList, {
              selectedIndex: selectedOrderLineIndex.value,
              "onUpdate:selectedIndex": _cache[0] || (_cache[0] = ($event: any) => ((selectedOrderLineIndex).value = $event)),
              items: order.value.orderLines.records,
              readOnly: ""
            }, null, 8, ["selectedIndex", "items"]),
            (selectedOrderLineIndex.value != null)
              ? (_openBlock(), _createBlock(ContentModal, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(OrderLineEditor, {
                      value: order.value.orderLines.records[selectedOrderLineIndex.value],
                      readOnly: ""
                    }, null, 8, ["value"]),
                    _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
                    _createVNode(Button, {
                      title: "Close",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (selectedOrderLineIndex.value = null))
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (order.value && order.value.customer && order.value.relationType == 'CUSTOMER')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (order.value.type == 'SALE_DEBIT')
              ? (_openBlock(), _createBlock(Button, {
                  key: 0,
                  title: "Send Invoice Mail",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (mailInvoice()))
                }))
              : _createCommentVNode("", true),
            (order.value.type == 'SALE_OFFER')
              ? (_openBlock(), _createBlock(Button, {
                  key: 1,
                  title: "Send Offer Mail",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (mailOffer()))
                }))
              : _createCommentVNode("", true),
            _cache[17] || (_cache[17] = _createElementVNode("h2", null, " Customer ", -1)),
            _createElementVNode("table", null, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _cache[14] || (_cache[14] = _createElementVNode("th", null, " Type ", -1)),
                  _createElementVNode("td", null, _toDisplayString(order.value.customer.type), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[15] || (_cache[15] = _createElementVNode("th", null, " Name ", -1)),
                  _createElementVNode("td", null, _toDisplayString(order.value.customer.name), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[16] || (_cache[16] = _createElementVNode("th", null, " Number ", -1)),
                  _createElementVNode("td", null, _toDisplayString(order.value.customer.number), 1)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (order.value && order.value.relationType == 'SUPPLIER' && order.value.supplier)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _cache[19] || (_cache[19] = _createElementVNode("h2", null, " Supplier ", -1)),
            _createElementVNode("table", null, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _cache[18] || (_cache[18] = _createElementVNode("th", null, " Name ", -1)),
                  _createElementVNode("td", null, _toDisplayString(order.value.supplier.name), 1)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (order.value && order.value.files)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _cache[21] || (_cache[21] = _createElementVNode("h2", null, " Files ", -1)),
            _createVNode(FileList, {
              selectedIndex: selectedFileIndex.value,
              "onUpdate:selectedIndex": _cache[4] || (_cache[4] = ($event: any) => ((selectedFileIndex).value = $event)),
              items: order.value.files.records,
              readOnly: ""
            }, null, 8, ["selectedIndex", "items"]),
            (selectedFileIndex.value)
              ? (_openBlock(), _createBlock(ContentModal, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(FileEditor, {
                      value: order.value.files.records[selectedFileIndex.value],
                      readOnly: ""
                    }, null, 8, ["value"]),
                    _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1)),
                    _createVNode(Button, {
                      title: "Close",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (selectedFileIndex.value = null))
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (error.value)
              ? (_openBlock(), _createBlock(ErrorModal, {
                  key: 1,
                  error: error.value,
                  "onUpdate:error": _cache[6] || (_cache[6] = ($event: any) => ((error).value = $event))
                }, null, 8, ["error"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})